import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// Public pages
import { About } from "@/pages/about";
// Admin pages
import { AdminLayout } from "@/pages/admin";
import { AdminContent } from "@/pages/admin/content";
import { AdminDashboard } from "@/pages/admin/dashboard";
import { AdminEducation } from "@/pages/admin/education";
import { AdminExperience } from "@/pages/admin/experience";
import { AdminPostEditor } from "@/pages/admin/post-editor";
import { AdminPostsList } from "@/pages/admin/posts-list";
import { AdminProjectEditor } from "@/pages/admin/project-editor";
import { AdminProjectsList } from "@/pages/admin/projects-list";
import { AdminSettings } from "@/pages/admin/settings";
import { AdminSocialLinks } from "@/pages/admin/social-links";
import { Home } from "@/pages/home";
import { NotFound } from "@/pages/not-found";
import { Projects } from "@/pages/projects";
import { Unauthorized } from "@/pages/unauthorized";
import { Writing } from "@/pages/writing";
import { WritingPost } from "@/pages/writing-post";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/writing" element={<Writing />} />
          <Route path="/writing/:slug" element={<WritingPost />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Admin routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="posts" element={<AdminPostsList />} />
            <Route path="posts/:id" element={<AdminPostEditor />} />
            <Route path="projects" element={<AdminProjectsList />} />
            <Route path="projects/:id" element={<AdminProjectEditor />} />
            <Route path="content" element={<AdminContent />} />
            <Route path="experience" element={<AdminExperience />} />
            <Route path="education" element={<AdminEducation />} />
            <Route path="social-links" element={<AdminSocialLinks />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
